/*

Structure is

{
  [internalEventName]: {
    [vendorId]: { // currently 'google' or 'omniture'

    }
  }
}

If the internal event name is not listed, no vendors will track the event.

If, for a listed event, a vendor is not listed (or explicitly set to false) that vendor will not track the event.

The object given for a vendor under an event has two properties;
  name:     Optionally maps the internal name to the eventName for that vendor.
            If omitted the internal name is passed through.

  paramMap: Optional configuration that tells the eventParams method of the vendor specific API class how to
                convert the given data.
            If omitted, an empty map is passed, which will probably result in no params being sent (although
                a vendor may behave differently).

Note that both properties are optional. If neither is needed it is still necessary to provide an empty object, or
    the event will nto be tracked by that vendor.

*/

export default {
  deviceIDFA: {
    signal: {
      paramMap: {
        deviceIDFA: "deviceIDFA"
      }
    }
    //no google
    //no omniture
  },
  pageView: {
    signal: {
      name: "pageLoad",
      paramMap: {
        pageUrl: "url"
      }
    },
    google: {
      name: "pageview"
    },
    omniture: {
      options: {
        isPage: true
      }
    }
  },
  playVideo: {
    //no signal
    //no google
    omniture: {
      paramMap: {
        events: ["event11"],
        evars: {
          videoUri: "eVar28"
        }
      }
    }
  },
  followMatch: {
    //no signal
    //no google
    omniture: {
      paramMap: {
        events: ["event6"],
        evars: {
          matchId: "eVar75"
        }
      }
    }
  },
  followMeeting: {
    //no signal
    //no google
    omniture: {
      paramMap: {
        events: ["event6"],
        evars: {
          meetingId: "eVar76"
        }
      }
    }
  },
  followRace: {
    //no signal
    //no google
    omniture: {
      paramMap: {
        events: ["event6"],
        evars: {
          raceId: "eVar77"
        }
      }
    }
  },
  addToBetSlip: {
    //no signal
    //no google
    omniture: {
      paramMap: {
        events: ["event31"]
      }
    }
  },
  reportTimings: {
    //no signal
    //no google
    omniture: {
      paramMap: {
        events: ["event10"],
        evars: {
          LocationCheck : "eVar58",
          SiteLoad : "eVar59",
          applicationLoadTime : "eVar60"
        }
      }
    }
  },
  insidersLinkClick: {
    omniture: {
      paramMap: {
        props: {
          link : "prop15"
        }
      }
    }
  },
  insightsLinkClick: {
    omniture: {
      paramMap: {
        props: {
          link : "prop15"
        }
      }
    }
  },
  linkClick: {
    omniture: {
      paramMap: {
        props: {
          link : "prop15"
        }
      }
    }
  },
  arrivingUser: {
    //no signal
    //no google
    omniture: {
      paramMap: {        
        evars: {
          custId : "eVar39"
        }
      }
    }
  },       
};



// WEBPACK FOOTER //
// ./utils/AnalyticsEventMap.js